import { render, staticRenderFns } from "./PendingApprovalRequest.vue?vue&type=template&id=3427e124"
import script from "./PendingApprovalRequest.vue?vue&type=script&lang=js"
export * from "./PendingApprovalRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports